module.exports = __webpack_public_path__ + "static/media/curemed.99514610.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/curemed.png
// module id = 2798
// module chunks = 0